import {v4} from 'uuid';

import {nowISOString} from 'app/demo/utils';

import {LaneSerializedType, ListResponseType} from 'sweet-types';

const now = nowISOString();

export const lanes_list_fixture: ListResponseType<LaneSerializedType> = {
  count: 2,
  next: null,
  previous: null,
  results: [
    {
      hashid: 'Q7IA2D',
      name: 'Teammate',
      modified_at: now,
      created_at: now,
    },
    {
      hashid: '0qT8v9',
      name: 'Manager',
      modified_at: now,
      created_at: now,
    },
  ],
  num_pages: 1,
};

export function createLane(name: string): LaneSerializedType {
  return {
    name,
    hashid: v4(),
    modified_at: nowISOString(),
    created_at: nowISOString(),
  };
}

export function addLaneToList(
  lane: LaneSerializedType,
  laneList: ListResponseType<LaneSerializedType>
) {
  laneList.count += 1;
  laneList.results = [...laneList.results, lane];
  laneList.results.sort(({name: a}, {name: b}) =>
    a.toLowerCase() < b.toLowerCase()
      ? -1
      : a.toLowerCase() > b.toLowerCase()
      ? 1
      : 0
  );
}
